import React, { useRef } from "react";
import Icon from "../../../assets/icons/Icon";
// import "./CustomTabs.css";

export const Tab = () => null;

export const Tabs = ({ id, activeKey, onSelect, className = "", children }) => {
  const tabs = React.Children.toArray(children).filter(Boolean);

  const navRef = useRef(null);

  const scrollLeft = () => {
    navRef.current?.scrollBy({ left: -200, behavior: "smooth" });
  };

  const scrollRight = () => {
    navRef.current?.scrollBy({ left: 200, behavior: "smooth" });
  };

  return (
    <>
      <div className="custom-tabs-shell">
        <button
          type="button"
          className="custom-tabs__nav-btn custom-tabs__nav-btn--left"
          onClick={scrollLeft}
          aria-label="Scroll tabs left"
        >
          <Icon name="ChevronLeft" className="icon_button" cursorPointer />
        </button>
        <div id={id} className={`custom-tabs ${className}`}>
          <div ref={navRef} className="custom-tabs-nav">
            {tabs.map((tab) => {
              const { eventKey, title, disabled } = tab.props;
              const isActive = activeKey === eventKey;

              return (
                <button
                  key={eventKey}
                  type="button"
                  className={`custom-tab-btn ${isActive ? "active" : ""}`}
                  onClick={() => !disabled && onSelect?.(eventKey)}
                  disabled={disabled}
                >
                  {title}
                </button>
              );
            })}
          </div>
        </div>
        <button
          type="button"
          className="custom-tabs__nav-btn custom-tabs__nav-btn--right"
          onClick={scrollRight}
          aria-label="Scroll tabs right"
        >
          <Icon name="ChevronRight" className="icon_button" cursorPointer />
        </button>
      </div>
      <div className="custom-tabs-content">
        {tabs.map((tab) => {
          const { eventKey, children } = tab.props;

          if (eventKey !== activeKey) return null;

          return (
            <div key={eventKey} className="custom-tab-pane">
              {children}
            </div>
          );
        })}
      </div>
    </>
  );
};
